/**
 * Error Modal Store
 *
 * Zustand store for managing the error details modal.
 * Allows showing detailed error information from anywhere in the app.
 */

import { create } from "zustand";
import type { ApiError } from "./types";

interface ErrorModalState {
  /** Whether the error modal is open */
  isOpen: boolean;
  /** The current error being displayed */
  error: ApiError | Error | null;
  /** Open the error modal with an error */
  openErrorModal: (error: ApiError | Error) => void;
  /** Close the error modal */
  closeErrorModal: () => void;
}

export const useErrorModalStore = create<ErrorModalState>((set) => ({
  isOpen: false,
  error: null,
  openErrorModal: (error) => set({ isOpen: true, error }),
  closeErrorModal: () => set({ isOpen: false, error: null }),
}));
